import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import '@/styles/app.css';
import { App } from '@/App';
import { ErrorBoundary } from '@/shell/ErrorBoundary';
import { db } from '@/db/db';
import { watchCoreData } from '@/data/core';
import { importV1IfPresent, defaultSettings } from '@/db/importV1';
import { hlc } from '@/lib/device';
import { applyTheme, readThemePref } from '@/lib/theme';
import { setServerOffset } from '@/lib/clock';
import { SYNC_META } from '@/sync/state';

applyTheme(readThemePref());

// Local data first: ensure a settings row exists, then adopt any v1 data on this origin.
void (async () => {
  if (!(await db.settings.get('settings'))) await db.settings.put(defaultSettings(hlc.now()));
  // Only now, so the first values the app sees are the stored ones rather than the defaults above.
  watchCoreData();
  const offset = (await db.meta.get(SYNC_META.offset))?.value;
  if (typeof offset === 'number') setServerOffset(offset);
  const r = await importV1IfPresent(db, () => hlc.now());
  if (r) console.info('[timato] imported v1 data', r);
})();

// A new build is live: reload on the next quiet moment rather than mid-session.
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    void import('sonner').then(({ toast }) => toast('A new version is ready', { duration: Infinity, action: { label: 'Reload', onClick: () => void updateSW(true) } }));
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
